function create_product_add_to_cart()
{
  var form = $("#buildCustomBox");
  // you can't pass Jquery form it has to be javascript form object
  var formData = new FormData(form[0]);
  console.log('k-formData', formData);

  	for(var pair of formData.entries()) {
      console.log('formdataEntry:', pair[0]+ ', '+ pair[1]);
	}

  $.ajax({
    type: 'POST',
    url: 'https://dyov3.bbgiftcoapp1.com/shopify/dyo/create',
    data: formData,
    contentType: false,
    processData: false,
    success: function (data) {
      console.log('k-response-data', data);
      if (data.status === true) {
        const variant_id = data.variant_id;
        const properties_list = {
          'Box': data.properties.box,
          'Box contents': data.properties.box_contents,
          'Ribbon name': data.properties.ribbon_name,
          'Ready preference': data.properties.ready_preference_user,
          'Card name': data.properties.card_name,
          'Leave card blank': data.properties.card_blank,
        }
        if ('delayed_until_date' === data.properties.ready_preference) {
          properties_list['Shipping Date'] = data.properties.shipping_date;
        }

        if ('No' === data.properties.card_blank) {
          properties_list['Card to'] = data.properties.card_to;
          properties_list['Card from'] = data.properties.card_from;
          properties_list['Card message'] = data.properties.message;
        }

        const cart_add_data = { items: [] };

        if ('rush' === data.properties.ready_preference) {
          // add the rush item first so it ends up second in the cart (they're added sequentially)
          cart_add_data.items.push({
            // rush order variant ID
            id: 39703410016310,
            quantity: 1,
          });
        }

        cart_add_data.items.push({
          quantity: 1,
          id: variant_id,
          properties: properties_list,
        });

        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          dataType: 'json',
          cache: false,
          data: cart_add_data,
          success: function (response) {
            $("#build-complete .please-wait-loading.status-icon,#build-complete .step-description").hide();
            $("#build-complete .build-buttons.visible").show();
            $("#build-complete .step-title.secondary").show();
            $("#build-complete .step-title.primary ,#build-complete .status-icon.fa.fa-check.success").show();

            $(".js-step-trigger .step-li-5").removeClass('isActive');

            $(".js-step-trigger .step-li-5 .js-step-trigger-5").removeClass('isActive');

          },
          error: function (error) {
            alert('Something went wrong. Please try again.');
          }

        });
      } else {
        alert('Something went wrong. Please try again later.');
      }

    }
  });
}

function manageSteps(data_index)
{
  $(".step-trigger.js-step-trigger li").each(function(){
    var data_index_2 = $(this).children('a').attr('data-index');
    if(data_index_2 > data_index)
    {
      $(this).addClass('make-untouchable');
    }
    else
    {
      $(this).removeClass('make-untouchable');
    }
  })
}

function changeStep(newStep) {
  // find the .js-step > .js-step-content element, remove all classes and then add class that will "move" (translate) the content to the left
  $('.js-step').find('.js-step-content').removeClass().addClass('js-step-content step-content_'+newStep);
}

function totalpriceAddedproduct()
{
  var pureprice = 0 ;
  var p_pureprice ;
  var prod_id ;
  var prod_id_group = '' ;
  $(".product_container .prod_list li a").each(function(){
    var proquant = parseInt($(this).children(".curadded").html());
    p_pureprice = parseInt($(this).attr("data-pureprice"));
    if(isNaN(proquant)) {
      prod_id = $(this).attr("data-id");
    }else{
    prod_id = $(this).attr("data-id")+"-"+proquant;
    }
    if(prod_id != '')
    {
      prod_id_group = prod_id_group+prod_id+',';
    }
    if($(this).parents("li").hasClass("type__products")){
      var getqunt = $(this).parents("li").attr("data-added");
      p_pureprice = parseInt(getqunt)*p_pureprice;
    }

    pureprice =  pureprice + p_pureprice;
  });

  /********* ADD RIBBON PRICE BLOCK START HERE ****************/
  if( $(".collection_ribbons_container li.selected_card ").length > 0 ){
    var ribbon_price = parseInt( $(".collection_ribbons_container li.selected_card ").attr("data-pureprice"));
    pureprice = pureprice + ribbon_price;
  }
  /********* ADD RIBBON PRICE BLOCK END HERE ****************/
  pureprice = (pureprice / 100).toFixed(2) ;
  $('.p_title_list .list-subtotal .subtotal').text('$'+pureprice);
  $(".step_2container #box_product_ids").val(prod_id_group);
  return pureprice;
}

/**
 * This grabs the steps in the header & adds a click function.
 * These are clicked by other JS to change the step.
 */
$(document).ready(Steps = function(){
  var trigger = '.js-step-trigger';

  var stepTriggers = $('.js-step').find(trigger);

  $('.js-step-trigger').hide();

  stepTriggers.find('li').click(function (g) {
    g.preventDefault();
    var index = $(this).find('a').attr('data-index');
    $(trigger).show();
    $(trigger).find('li a').removeClass('isActive');
    $(trigger).find('li:eq(' + index + ') a').addClass('isActive');
  });

  // for each of the steps (li's) in the step nav, add a click event
  // numbers match the step-content_# classes and build-step-#.liquid files
  // 1 = packaging
  // 2 = items
  // 3 = card
  // 4 = accent/ribbon
  // 5 = shipping
  // 6 = done (not clickable)
  stepTriggers.find('li:eq(0)').click(function() {
    changeStep(2);
  });
  stepTriggers.find('li:eq(1)').click(function() {
    changeStep(4);
  });
  stepTriggers.find('li:eq(2)').click(function() {
    changeStep(5);
  });
  stepTriggers.find('li:eq(3)').click(function(){
    changeStep(6);
  });
  stepTriggers.find('li:eq(4)').click(function(){
    changeStep(7);
  });
  stepTriggers.find('li:eq(5)').click(function(){
    changeStep(8);
  });

  $(".step-trigger.js-step-trigger li").click(function(){
    var data_index = $(this).children('a').attr('data-index');
    manageSteps(data_index);
  });

  var data_index = 0;
  manageSteps(data_index);
});

function AddToBoxList(currentThis)
{
 //console.log("justcheckingintoit");
  var prod_id = $(currentThis).attr("data-id");
  var prod_name = $(currentThis).attr("data-product-name");
  var prod_img = $(currentThis).attr("data-product-img");
  // not sure if this one is used or is grabbing from the right place (DH 2025-11-28)
  var prod_price = $(currentThis).attr("data-price");
  var prod_pureprice = $(currentThis).attr("data-pureprice");
  var prod_weight = $(currentThis).attr("data-productweight");
  var currentadded = $(currentThis).siblings(".addedinthebox").children("span").children(".addednumber").html();
  currentadded = parseInt(currentadded);
  if(isNaN(currentadded)) {
    currentadded = 1;
  }
  console.log("currentadded="+currentadded);
  var prod_pureprice_new = parseFloat(prod_pureprice) * parseFloat(currentadded);
  prod_pureprice_new = (prod_pureprice_new/100).toFixed(2);
  prod_price = "$"+prod_pureprice_new+" CAD" ;
  var box_capacity = $("#selected_box_capacity_11").val();
  if (box_capacity.indexOf('-') > -1)
  {
    box_capacity = box_capacity.split("-");
    var min_data = parseInt(box_capacity[0]); var max_data = parseInt(box_capacity[1]);
    //  console.log("min_data : "+min_data+" == max_data :"+max_data);
  }
  else
  {
    var min_data = parseInt(box_capacity); var max_data = parseInt(box_capacity);
  }

 // var total_prod_in_box = ($(".product_container .prod_list li.type__products").length - 1);

  var li_html = '<li class="products_in_box type__products" data-added="'+currentadded+'">'+
      '<a href="javascript:void(0)" data-productweight="'+prod_weight+'" data-id="'+prod_id+'" data-pureprice="'+prod_pureprice+'" >'+
      '<img src="'+prod_img+'" title="'+prod_name+'">'+
      '<div class="quantity-badge"><span></span><span></span></div><div class="curadded">'+currentadded+'</div>'+
      '</a>'+
      '</li>';
  var title_list = '<li class="type__productPrice">'+
      '<div class="quantity">1</div>'+
      '<div class="name">'+prod_name+'</div>'+
      '<div class="price"><span class="base-price">'+prod_price+'</span></div>'+
      '<div class="remove-product" data-id="'+prod_id+'" ><span class="remove" ><span></span><span></span></span></div>'+
      '</li>';
  var is_product_added = $('.product_container .prod_list li a[data-id="'+prod_id+'"]').length;
  var total_prod_in_box = 0;
  $(".product_container .prod_list li.type__products").each(function(){
    var cuur = $(this).attr("data-added");
    total_prod_in_box = parseInt(total_prod_in_box) + parseInt(cuur);
  })
  //var total_prod_in_box = $(".product_container .prod_list li.type__products").length;
  // console.log('max_data :::'+max_data+' total_prod_in_box : '+total_prod_in_box);
  if(max_data > total_prod_in_box )
  {

    if(is_product_added == 0 || typeof is_product_added == "undefined")
    {
      console.log("addingfirsttime");
      $(".product_container .prod_list").append(li_html);
      $(".bottom_info_bar_inner .image__box").append(li_html);
      $(".p_title_list .list-items").append(title_list);

      //$(currentThis).text('Product is added !') //.addClass("untouchable");
      $( '<span class="addedinthebox"><p class="addedintheboxminus" id="addedintheboxminus">-</p><span><span class="addednumber" id="addednumber">1</span> in a box</span><p class="addedintheboxplus">+</p></span>' ).insertAfter( $(currentThis) );
      $(currentThis).addClass("wecanhideitnow");
      $(currentThis).parents(".controls.custome-addto.cart").addClass("quantityaddednow");
      $(currentThis).parents(".product__infor__box").addClass("qntyaddedparent");
      setTimeout(function(){
        $("a.close-product-popup").trigger("click");
      }, 700);

      //$("#product_modal_popup_113 .close-product-popup").click();
      totalpriceAddedproduct();

      // check again and alert
      var total_prod_in_box = $(".product_container .prod_list li.type__products").length;
      if(max_data == total_prod_in_box){

        setTimeout(function(){
          $("#alert-alert-read .alert-footer").show();
          if(max_data == 3){
            var insert_html = 'Your box is full with <span class="box_capacityy">'+max_data+' items. You can always change the size of your box to add more items by selecting Step 1 in your progress bar</span> '
          }
          else{
          var insert_html = 'YOUR BOX IS FULL WITH <span class="box_capacityy">'+max_data+' ITEMS</span> '
          }
          $("#alert-alert-read .alert-desc").html(insert_html);
          $("#overlay_of_box_11,#alert-alert-read").fadeIn();
        }, 1000);

      }



    }
    else
    {
      console.log("addinganothertiime");
      $(".product_container .prod_list .type__products").each(function(){
        var getidd = $(this).children("a").attr("data-id");
        if(getidd == prod_id){
          $(this).attr("data-added",currentadded)
          $(this).children("a").children(".curadded").html(currentadded);
        }
      })

      $(".p_title_list .list-items .type__productPrice").each(function(){
        var getidd = $(this).children(".remove-product").attr("data-id");
        if(getidd == prod_id){
          $(this).children(".quantity").html(currentadded);
          $(this).children(".price").children(".base-price").html(prod_price);
        }
      })

      //$(".product_container .prod_list").append(li_html);
      $(".bottom_info_bar_inner .image__box").append(li_html);
      //$(".p_title_list .list-items").append(title_list);

      //$(currentThis).text('Product is added !') //.addClass("untouchable");
      //$(currentThis).html('<span class="addedinthebox"><p class="addedintheboxminus">-</p><span><span class="addednumber">1</span> in a box</span><p class="addedintheboxplus">+</p></span>');
      // $( '<span class="addedinthebox"><p class="addedintheboxminus" id="addedintheboxminus">-</p><span><span class="addednumber" id="addednumber">1</span> in a box</span><p class="addedintheboxplus">+</p></span>' ).insertAfter( $(currentThis) );
      setTimeout(function(){
        $("a.close-product-popup").trigger("click");
      }, 700);

      //$("#product_modal_popup_113 .close-product-popup").click();
      totalpriceAddedproduct();

      // check again and alert
      var total_prod_in_box = 0;
      $(".product_container .prod_list li.type__products").each(function(){
        var cuur = $(this).attr("data-added");
        total_prod_in_box = parseInt(total_prod_in_box) + parseInt(cuur);
      })
      //var total_prod_in_box = $(".product_container .prod_list li.type__products").length;
      if(max_data == total_prod_in_box){

        setTimeout(function(){
          $("#alert-alert-read .alert-footer").show();
          //var insert_html = 'YOUR BOX IS FULL WITH <span class="box_capacityy">'+max_data+' ITEMS</span> '
          if(max_data == 3){
            var insert_html = 'Your box is full with <span class="box_capacityy">'+max_data+' items. You can always change the size of your box to add more items by selecting Step 1 in your progress bar</span> '
          }
          else{
          var insert_html = 'YOUR BOX IS FULL WITH <span class="box_capacityy">'+max_data+' ITEMS</span> '
          }
          $("#alert-alert-read .alert-desc").html(insert_html);
          $("#overlay_of_box_11,#alert-alert-read").fadeIn();
        }, 1000);

      }
      //   $(currentThis).text('Product is already added !') //.addClass("untouchable");
    }
  }
  else
  {
    if(max_data == total_prod_in_box){

      setTimeout(function(){
        $("#alert-alert-read .alert-footer").show();
        //var insert_html = 'YOUR BOX IS FULL WITH <span class="box_capacityy">'+max_data+' ITEMS</span> '
        if(max_data == 3){
          var insert_html = 'Your box is full with <span class="box_capacityy">'+max_data+' items. You can always change the size of your box to add more items by selecting Step 1 in your progress bar</span> '
          }
        else{
          var insert_html = 'YOUR BOX IS FULL WITH <span class="box_capacityy">'+max_data+' ITEMS</span> '
          }
        $("#alert-alert-read .alert-desc").html(insert_html);
        $("#overlay_of_box_11,#alert-alert-read").fadeIn();
      }, 1000);

    }
    /*
        if( (is_product_added == 0 || typeof is_product_added == "undefined") && total_prod_in_box !=11 )
        {
          $("#alert-alert-read .alert-footer").show();
          var insert_html = 'YOUR BOX IS FULL WITH <span class="box_capacityy">'+max_data+' ITEMS</span> '
          $("#alert-alert-read .alert-desc").html(insert_html);
          $("#overlay_of_box_11,#alert-alert-read").fadeIn();
          console.log('if block ');
        }
        else
        {
          $("#overlay_of_box_11,#alert_alert_read_4").fadeIn();
          console.log("else condition working");
        } */
  }
}


/****************** REMOVE PRODUCT BLOCK START HERE **********************/
$('body').on('click', '.step_2container ul li .remove-product', function(){
  $(this).parents('li').remove();
  var product_id = $(this).attr('data-id');
  $(".step_2container .product_container ul li a[data-id='"+product_id+"']").parent('li').remove(); // remove from box
  $(".collection_Prod_container ul li[data-id='"+product_id+"'] .controls .AddtoBox").text('Add to Box').removeClass('untouchable'); //reset text ADD TO CART
  $(".collection_Prod_container ul li[data-id='"+product_id+"'] .controls .AddtoBox").removeClass('wecanhideitnow'); //reset text ADD TO CART
  $(".collection_Prod_container ul li[data-id='"+product_id+"'] .controls .AddtoBox").siblings("span.addedinthebox").remove();
  totalpriceAddedproduct();
});

$('body').on('click', '.step_2container .product_container li .quantity-badge', function(){
  var product_id = $(this).parents('a').attr('data-id');
  $(this).parents('li').remove();

  $(".step_2container .p_title_list ul li div[data-id='"+product_id+"']").parent('li').remove(); // remove from box
  $(".collection_Prod_container ul li[data-id='"+product_id+"'] .controls .AddtoBox").text('Add to Box').removeClass('untouchable'); //reset text ADD TO CART
  $(".collection_Prod_container ul li[data-id='"+product_id+"'] .controls .AddtoBox").removeClass('wecanhideitnow'); //reset text ADD TO CART
  $(".collection_Prod_container ul li[data-id='"+product_id+"'] .controls .AddtoBox").siblings("span.addedinthebox").remove();
  totalpriceAddedproduct();
});


/****************** REMOVE PRODUCT BLOCK END HERE **********************/

$(document).ready(function(){
  var slider_container = $(".step .slider_container_cover > .step-content").width();
  var slider_container_box = $(".step .slider_container_cover > .step-content").width();
  // 8 is the number of steps
  slider_container_box = slider_container_box * 8;
  $('.step .slider_container_cover > .step-content').css('width' , slider_container_box+'px');
  $('.step .slider_container_cover .step-content-item').css('width' , slider_container+'px');



  /****************** STEP 1 BLOCK START HERE **********************/
  $("#b-stepp-2 ul li.main-parent").click(function(){
    $(this).siblings("li.main-parent").find('.sub-items').slideUp();
    $(this).find('.sub-items').slideToggle();
  });

  /**
   * Click on second level of box
   */
  $("#b-stepp-2 ul li .sub-items ul li").click(function(){
    var boxEl = this;

    var data_capacity = $(this).attr("data-capacity");
    var org_data_capacity = $(this).attr("data-capacity");
    var weight_capacity = $(this).attr("data-weight");
    $("#selected_box_weight_capacity_11").val(weight_capacity);

    var min_data, max_data;
    if (data_capacity.indexOf('-') > -1)
    {
      data_capacity = data_capacity.split("-");
      min_data = parseInt(data_capacity[0]);
      max_data = parseInt(data_capacity[1]);
    }
    else
    {
      min_data = parseInt(data_capacity);
      max_data = parseInt(data_capacity);
    }
   // var total_prod_in_box = ($(".product_container .prod_list li.type__products").length - 1);

    var total_prod_in_box = 0;
    $(".product_container .prod_list li.type__products").each(function(){
      var cuur = $(this).attr("data-added");
      total_prod_in_box = parseInt(total_prod_in_box) + parseInt(cuur);
    })

    if(max_data < total_prod_in_box)
    {
      $("#overlay_of_box_11, #alert_alert_read_2").fadeIn();

      return;
    }

    $(".js-confirm-box_name").text($(this).attr('data-product-name-display'));
    $(".js-confirm-box_image").attr('src', $(this).attr('data-product-img')).attr('alt', $(this).attr('data-product-name-display'));
    $(".js-confirm-box_min").text(min_data);
    $(".js-confirm-box_max").text(max_data);
    // used
    $(".js-confirm-box_price").text($(this).attr('data-price'));
    $(".js-confirm-box_description").html($(this).attr('data-product-description') || '');

    $("html, body").animate({ scrollTop: 0 }, "slow");

    // delay so the image will be updated/loaded before they get there
    setTimeout(function() {
      changeStep(3);
    }, 500);

    $('#confirm_box-change').click(function() {
      // go back to step 2
      changeStep(2);
    });

    $("#confirm_box-continue").click(function() {
      $("#b-stepp-2 ul li .sub-items ul li").removeClass('build_box_selected');

      $("html, body").animate({ scrollTop: 0 }, "slow");

      var selected_box_id = $(boxEl).attr("data-box-id");
      /*********remove old box start here ************/
      var prev_box_id = $("#selected_box_11").val();
      // remove from box
      $(".step_2container .product_container ul li a[data-id='"+prev_box_id+"']").parent('li').remove();
      // reset text ADD TO CART
      $(".step_2container ul li .empty-area[data-id='"+prev_box_id+"']").parents('li').remove();
      /*********remove old box end here  ************/
      $("#selected_box_11").val(selected_box_id);
      $(boxEl).addClass('build_box_selected');

      setTimeout(function(){
        $(".step-trigger .step-li-2").click().removeClass('make-untouchable');
      },500);

      var prod_id = $(boxEl).attr("data-box-id");
      var prod_name = $(boxEl).attr("data-product-name");
      var prod_img = $(boxEl).attr("data-product-img");
      // used
      var prod_price = $(boxEl).attr("data-price");
      var prod_pureprice = $(boxEl).attr("data-pureprice");

      $("#selected_box_capacity_11").val(org_data_capacity);
      $("#selected_variant_name").val(prod_name);
      var li_html = '<li>'+
          '<a href="javascript:void(0)" data-id="'+prod_id+'" data-pureprice="'+prod_pureprice+'" >'+
          '<img src="'+prod_img+'" title="'+prod_name+'">'+
          '</a>'+
          '</li>';
      var title_list = '<li>'+
          '<div class="quantity">1</div>'+
          '<div class="name">'+prod_name+'</div>'+
          '<div class="price"><span class="base-price">'+prod_price+'</span></div>'+
          '<div class="empty-area" data-id="'+prod_id+'" ></div>'+
          '</li>';
      var is_product_added = $('.product_container .prod_list li a[data-id="'+prod_id+'"]').length;
      if(is_product_added == 0 || typeof is_product_added == "undefined")
      {
        $(".product_container .prod_list").prepend(li_html);
        $(".p_title_list .list-items").prepend(title_list);
        // console.log("test");
        $(boxEl).find('.controls').find('span').html('<span class="addedinthebox"><p class="addedintheboxminus">-</p>1 in a box<p class="addedintheboxplus">+</p></span>');
        //$(boxEl).find('.controls').find('span').text('Product is added !');
        setTimeout(function(){
          $("a.close-product-popup").trigger("click");
        }, 700);
        totalpriceAddedproduct();

        $("#overlay_of_box_11, #alert-alert-box").fadeOut();
      }

      $("html, body").animate({ scrollTop: 0 }, "slow");

      // go to step 4
      changeStep(4);
    });
  });

  /****************** STEP 1 BLOCK END HERE **********************/

  /****************** STEP 2 BLOCK START HERE **********************/

  function initilizTheSlider()
  {
    var owl = $('.owl-carousel-1100');
    owl.owlCarousel({
      margin: 10,
      nav: true,
      loop: false,
      dots:false,
      items:1,
      thumbs: true,
      thumbImage: true,
      thumbContainerClass: 'owl-thumbs',
      thumbItemClass: 'owl-thumb-item',

      responsive: {
        0: {
          items: 1
        },
        600: {
          items: 1
        },
        1000: {
          items: 1
        }
      }
    })
  }

  $('body').on('click', '#b-stepp-4 .collection_Prod_container ul li .controls .single .AddtoBox', function(event) {
    var currentThis = this;
    AddToBoxList(currentThis);
  })

  // popup open code
  $('body').on('click', '#b-stepp-4 .collection_Prod_container ul li figure img', function() {

    $(".popupopenedli").removeClass("popupopenedli");
    $(this).parents("li").addClass("popupopenedli");
    var prod_id = $(this).parents('li').attr("data-id");
    var prod_name = $(this).parents('li').attr("data-product-name");
    var prod_img = $(this).attr("data-product-img");
    // not sure if this one is used or is grabbing from the right place (DH 2025-11-28)
    var prod_price = $(this).parents('li').attr("data-price");
    var prod_pureprice = $(this).parents('li').attr("data-pureprice");
    var prod_description = $(this).parents("figure").siblings(".prooodescription").html();
    var prod_weight = $(this).parents('li').attr("data-weight");


    var is_product_added = $('.product_container .prod_list li a[data-id="'+prod_id+'"]').length;
    console.log("is_product_added=="+is_product_added);
    if(is_product_added == 0 || typeof is_product_added == "undefined")
    {
      var img_html = ' <span class="btn btn--large btn--full btn--clear AddtoBox" >Add to Box</span>';
      $(".already_added").removeClass("already_added");
       $("#product_modal_popup_113 span.addedinthebox").remove();
      $("#product_modal_popup_113 .wecanhideitnow").removeClass("wecanhideitnow");
      $("#product_modal_popup_113 .qntyaddedparent").removeClass("qntyaddedparent");

    }
    else
    {
      $("#product_modal_popup_113 .controls").addClass("already_added");
      var cuurentlyadded = $('.product_container .prod_list li a[data-id="'+prod_id+'"]').children(".curadded").html();
      cuurentlyadded = parseInt(cuurentlyadded);
      console.log("cuurentlyadded=="+cuurentlyadded);

      var img_html = '<span class="addedinthebox"><p class="addedintheboxminus" id="addedintheboxminus">-</p><span><span class="addednumber" id="addednumber">'+cuurentlyadded+'</span> in a box</span><p class="addedintheboxplus">+</p></span>';
      $("#product_modal_popup_113 span.addednumber").html(cuurentlyadded);
     // var img_html = 'Product is already added !' ;
    }

    prod_img = prod_img.split(',');
    var total_url = prod_img.length;
    var items_html = '';
    var items_html_thumb = '';
    for(var z = 0;z<total_url;z++)
    {
      if(prod_img[z] != ''){
        items_html += '<div data-thumb="test" class="item"><img src="'+prod_img[z]+'" /></div>';

      }
    }
    var prod_img_html ='<div class="owl-carousel owl-theme owl-carousel-1100" data-slider-id="1">'+items_html+'</div>';
    $("#product_modal_popup_113 .product__modal__box__inner #product_image_block_11").html(prod_img_html);


    $("#product_modal_popup_113 .product__modal__box__inner .product__infor__box .Add_to_cart_popup").html(img_html);

    $("#product_modal_popup_113 .product__modal__box__inner .blackbow-buy-buttons").attr('data-id',prod_id);
    $("#product_modal_popup_113 .product__modal__box__inner .product__infor__box .product__name").text(prod_name);
    $("#product_modal_popup_113 .product__modal__box__inner .product__infor__box .product__price").text(prod_price);
    $(".pro-price .product__price").text("$"+prod_price);
    $("#product_modal_popup_113 .product__modal__box__inner .product__infor__box .Add_to_cart_popup").attr('data-pureprice',prod_pureprice);
    // not sure if this one is used or is grabbing from the right place (DH 2025-11-28)
    $("#product_modal_popup_113 .product__modal__box__inner .product__infor__box .Add_to_cart_popup").attr('data-price',prod_price);
    $("#product_modal_popup_113 .product__modal__box__inner .product__infor__box .Add_to_cart_popup").attr('data-id',prod_id);
    $("#product_modal_popup_113 .product__modal__box__inner .product__infor__box .Add_to_cart_popup").attr('data-product-img',prod_img);
    $("#product_modal_popup_113 .product__modal__box__inner .product__infor__box .Add_to_cart_popup").attr('data-product-name',prod_name);
    $("#product_modal_popup_113 .product__modal__box__inner .product__infor__box .Add_to_cart_popup").attr('data-productweight',prod_weight);
    $("#product_modal_popup_113 .product__modal__box__inner .product__infor__box .product__description").html(prod_description);
    $(".product__modal__overlay , #product_modal_popup_113").fadeIn();

    initilizTheSlider();

//     if($(this).siblings(".controls.custome-addto.cart").hasClass("quantityaddednow")){
//       console.log("testing123");
//       $("#product_modal_popup_113 span.addedinthebox").remove();
//       var getcopy = $(this).siblings(".controls").html();
//       $("#product_modal_popup_113 .controls").html();
//       $("#product_modal_popup_113 .controls").html(getcopy);

//     }
//     else{
//       console.log("testing1234");
//       $("#product_modal_popup_113 .wecanhideitnow").removeClass("wecanhideitnow");
//       $("#product_modal_popup_113 .qntyaddedparent").removeClass("qntyaddedparent");
//       $("#product_modal_popup_113 span.addedinthebox").remove();
//     }
  }) // end of product popup


  $(".product__modal__overlay").click(function(){
    $(".product__modal__overlay,#product_modal_popup_113").fadeOut();
  });
  $('body').on('click', '#product_modal_popup_113 .Add_to_cart_popup span.AddtoBox', function() {
    var currentThis = $(this).parents(".Add_to_cart_popup");
    AddToBoxList(currentThis);

    $( '<span class="addedinthebox"><p class="addedintheboxminus" id="addedintheboxminus">-</p><span><span class="addednumber" id="addednumber">1</span> in a box</span><p class="addedintheboxplus">+</p></span>' ).insertAfter( $(".popupopenedli .AddtoBox") );
    $(".popupopenedli .AddtoBox").addClass("wecanhideitnow");
  })

  $("#product_modal_popup_113 .close-product-popup").click(function(){
    $("#overlay_of_box_11,#alert-alert-read,#product_modal_popup_113 ,.product__modal__overlay").fadeOut();
  })
  /***************** STEP 2 BLOCK END HERE **********************/
  /****************** POP UP BLOCK START HERE **********************/
  $("#alert-alert-read #cancel_me_11").click(function(){
    $("#overlay_of_box_11, #alert-alert-read").fadeOut();
  });
  /*   $("#alert-alert-read #upgrade_box_11").click(function(){
     $(this).text("Please wait ...").css('pointers-events','none');
     var currentThis = $(this);
     var capacity = $("#b-stepp-2 #selected_box_capacity_11").val()
     if(capacity == 5)
     {
       setTimeout(function(){
         $("#b-stepp-2 ul li[data-product-name='Box-7']").click();
         var html_m ='<strong>Congrats!</strong> Your box is upgraded to Box-7';
         $("#alert-alert-read .alert-desc").html(html_m);
         currentThis.text('Yes');
         currentThis.parents(".alert-footer").hide();
       },2000);
     }
     else if(capacity == 7)
     {
        setTimeout(function(){
         $("#b-stepp-2 ul li[data-product-name='Box-10']").click();
         var html_m ='<strong>Congrats!</strong> Your box is upgraded to Box-10';
         $("#alert-alert-read .alert-desc").html(html_m);
          currentThis.text('Yes');
         currentThis.parents(".alert-footer").hide();
       },2000);

     }
     else if(capacity == 10)
     {

     }
      setTimeout(function(){
        $("#overlay_of_box_11,#alert-alert-read,#product_modal_popup_113 ,.product__modal__overlay").fadeOut();
       },7000);

  }); */

  $('.js-step-trigger-1').click(function() {
    $("html, body").animate({ scrollTop: 0 }, 'slow');
    $(".step-trigger .step-li-1").click().removeClass('make-untouchable').addClass('isActive');
  });

  $("#alert-alert-read .close-me-6").click(function(){
    $("#overlay_of_box_11, #alert-alert-read, #product_modal_popup_113, .product__modal__overlay").fadeOut();
  });
  $("#alert-alert-box .close-me-6").click(function(){
    $("#overlay_of_box_11,  #alert-alert-box").fadeOut();
  });
  $("#alert_alert_read_2 #cancelok_me_11").click(function(){
    $("#overlay_of_box_11, #alert_alert_read_2").fadeOut();
    $(".js-step-trigger .step-li-2").click();
  });
  $("#alert_alert_read_3 #cancelok_me_13").click(function(){
    $("#overlay_of_box_11, #alert_alert_read_3").fadeOut();
    setTimeout(function(){ $("#alert_alert_read_3 .alert-desc").text('Remember our mini boxes hold 2-3 items, large 4-6 and wood 6-9. Happy Shopping!'); }, 2000)
  });
  $("#alert_alert_read_4 #cancelok_me_14").click(function(){
    $("#overlay_of_box_11, #alert_alert_read_4").fadeOut();
  });



  /****************** POP UP BLOCK END HERE **********************/

  /****************** COMPLETE BOX BTN BLOCK END HERE **********************/
  $(".p_title_list #complete-box ,.bottom_info_bar .bottom_info_bar_inner #complete-box-1").click(function(){
    var box_capacity = $("#selected_box_capacity_11").val();
    if (box_capacity.indexOf('-') > -1)
    {
      box_capacity = box_capacity.split("-");
      var min_data = parseInt(box_capacity[0]);
      var max_data = parseInt(box_capacity[1]);
    }
    else
    {
      var min_data = parseInt(box_capacity);
      var max_data = parseInt(box_capacity);
    }

    var total_prod_in_box = 0;
    $(".product_container .prod_list li.type__products").each(function(){
      var cuur = $(this).attr("data-added");
      total_prod_in_box = parseInt(total_prod_in_box) + parseInt(cuur);
    })

    // var total_prod_in_box = ($(".product_container .prod_list li.type__products").length );
    if(total_prod_in_box == 0 && min_data == 1000)
    {
      $("#alert_alert_read_3 .alert-desc").text('Please add at least one item to fill your box.');
      $("#overlay_of_box_11,#alert_alert_read_3").fadeIn();
    }
    else
    {
      if(min_data > total_prod_in_box && min_data != 1000)
      {
          $("#alert_alert_read_3 .alert-desc").html('Your box holds '+min_data+'-'+max_data+' items. Add a few more items!<br>Happy Shopping!');
        $("#overlay_of_box_11,#alert_alert_read_3").fadeIn();
      }
      else
      {
        $(".js-step-trigger .step-li-3").click().removeClass('make-untouchable');
      }
    }

  })
  /****************** COMPLETE BOX BTN BLOCK END HERE **********************/

  /****************** step 3 CARD BLOCK END HERE **********************/

  function updateCard(prod_id,prod_name,prod_price,prod_pureprice,prod_img){
    $('.card-name-message-11').text(prod_name);
    var title_list = '<li class="type__productCardPrice">'+
        '<div class="quantity">1</div>'+
        '<div class="name">'+prod_name+'</div>'+
        '<div class="price"><span class="base-price">'+prod_price+'</span></div>'+
        '<div class="card-product" data-id="'+prod_id+'" ></div>'+
        '</li>';

    var product_html = '<li class="products_in_box type__cardproducts">'+
        '<a href="javascript:void(0)" data-id="'+prod_id+'" data-pureprice="'+prod_pureprice+'" >'+
        '<img src="'+prod_img+'" title="'+prod_name+'">'+
        '</a>'+
        '</li>';
    $(".step_2container .product_container ul.prod_list li.type__cardproducts").remove();
    $(".step_2container .product_container ul.prod_list").append(product_html);

    $(".step_2container .p_title_list ul li.type__productCardPrice").remove();
    $(".step_2container .p_title_list ul").append(title_list);
    totalpriceAddedproduct();
  }

  $("#b-stepp-5 .card_view_container .card_img_view span.change_card_11").click(function(){
    $("#b-stepp-5 .card_view_container").slideUp();
    setTimeout(function(){
      $("#b-stepp-5 .collection_cards_container").slideDown();
    },500)
  })
  $(".collection_cards_container ul li").click(function(){
    $(".collection_cards_container ul li").removeClass('selected_card');
    $(this).addClass('selected_card');
    var current_prod_img = $(this).attr('data-product-img');
    var current_prod_id = $(this).attr('data-id');

    var prod_id          = $(this).attr("data-id");
    var prod_name        = $(this).attr("data-product-name");
    var prod_img         = $(this).attr("data-product-img");
    // not sure if this one is used or is grabbing from the right place (DH 2025-11-28)
    var prod_price       = $(this).attr("data-price");
    var prod_pureprice   = $(this).attr("data-pureprice");
    var prod_description = $(this).children(".prooodescription").html();

    $("#b-stepp-5 #selected_card_id_11").val(current_prod_id);

    $('.card_view_container .card_img_view figure img').attr('src',current_prod_img);
    $("#b-stepp-5 .collection_cards_container").slideUp();

    setTimeout(function(){
      $("#b-stepp-5 .card_view_container").slideDown();
    },500)

    updateCard(prod_id,prod_name,prod_price,prod_pureprice,prod_img);
    // $("#b-stepp-6 .step-blk_cutbtn").trigger("click");
  });

  /****************** step 4 ribbon BLOCK start HERE **********************/

  $(".collection_ribbons_container ul li").click(function(){
    $('.collection_ribbons_container ul li').removeClass('selected_card');$(this).addClass('selected_card');
    var data_id = $.trim( $(this).attr("data-id") );
    $(".collection_ribbons_container #selected_ribbon_id_11").val(data_id);

    var getcombinedweight = 0;
    var boxproductweight = $(".build_box_selected").attr("data-productweight");
    var boxinnerproductweight = 0;
    $("#b-stepp-4 li.products_in_box.type__products").each(function(){
      var getadquantity = parseInt($(this).attr("data-added"));
      var getthisproweight = parseFloat($(this).children("a").attr("data-productweight"));
      getthisproweight = getthisproweight * getadquantity;
      boxinnerproductweight = parseFloat(getthisproweight) + parseFloat(boxinnerproductweight) ;
    })
    var selected_card = $(".collection_cards_container .selected_card").attr("data-productweight");
    var selected_ribbon = $(".collection_ribbons_container .selected_card").attr("data-productweight");
    getcombinedweight = parseFloat(boxproductweight) + parseFloat(boxinnerproductweight) + parseFloat(selected_card) + parseFloat(selected_ribbon) ;
    $("input#selected_box_weight_capacity_11").val(getcombinedweight);


    $("#b-stepp-6 .step-blk_cutbtn").trigger("click");
  })
  $("#alert-alert-read_ribbon .cancel_me_11").click(function(){
    $("#overlay_of_box_11, #alert-alert-read_ribbon").fadeOut();
  })

  $(".modal-card_img_view__btn").click(function(){

    var ribbon_id = $.trim( $(".collection_ribbons_container #selected_ribbon_id_11").val() );
    if(ribbon_id == ''){
      $("#overlay_of_box_11, #alert-alert-read_ribbon").fadeIn(); return false;
    }
    else
    {
      var box_product_html="";
      $(".step_2container .product_container ul li").each(function(){
        var prod_id = $(this).children('a').attr('data-id');
        var prod_img_src = $(this).find('img').attr('src');
        var prod_img_title = $(this).find('img').attr('title');
        box_product_html += '<li data-id="'+prod_id+'" > <div class="thumbnail">'+
          '<img class="box-color" src="'+prod_img_src+'" title="'+prod_img_title+'"></div>'+
          '<div class="name">'+prod_img_title+'</div>'+
          '</li>';
      })

      var card_id = $(".card_img_view #selected_card_id_11").val();
      var card_img_src = $(".collection_cards_container ul li[data-id='"+card_id+"'] img").attr('src');

      var selected_box_img_src = $("#b-stepp-2 ul li.build_box_selected figure img").attr("src");
      $("#b-stepp-done .custom-box-list-wrapper .box-card .card-summary-image img").attr('src',card_img_src);
      $("#build-complete .box-subtotal .subtotal").html('$'+totalpriceAddedproduct());
      $("#build-complete .build-summary .box-summary-image img").attr('src',selected_box_img_src);
      $("#build-complete .build-summary .custom-box-list-wrapper ul").html(box_product_html);

      /***********Ribbon html block start here *************/
      var ribbon_id = $(".collection_ribbons_container #selected_ribbon_id_11").val();
      var ribbon_img_src = $(".collection_ribbons_container ul li[data-id='"+ribbon_id+"'] img").attr('src');
      var ribbon_img_name = $(".collection_ribbons_container ul li[data-id='"+ribbon_id+"']").attr('data-product-name');

      $(".box-ribbon--block-11 .ribbon-image").attr('src',ribbon_img_src);
      $(".box-ribbon--block-11 .ribbon-name--11").text(ribbon_img_name);
      /***********Ribbon html block end here *************/

      $(".js-step-trigger .step-li-5").click().removeClass('make-untouchable').addClass('isActive');  // hit the done btn block
      $(".js-step-trigger .step-li-5 .js-step-trigger-5").addClass('isActive');

      //create_product_add_to_cart();
    }
  })




  $(".select_card_add_btn").click(function(){
    var card_message;
    if (!$('#leave-card-blank').is(':checked')) {
      var card_to = $('#card_to').val().toString().trim();
      var card_from = $('#card_from').val().toString().trim();
      var card_input_message = $('textarea#message_on_card_11').val().toString().trim();

      if ('' == card_input_message) {
        alert('If you\'d like to leave the card blank, check off the Leave card blank option. Otherwise, a message is required.');
        return;
      }

      card_message = '<b>Card To</b>: ' + card_to + '<br>' +
          '<b>Card From</b>: ' + card_from + '<br>' +
          '<b>Card Message</b>: ' + card_input_message;
    } else {
      card_message = "Leave card blank";
    }
    $(".card-name-message-description").html(card_message);

    $(".js-step-trigger .step-li-4").click().removeClass('make-untouchable');  // hit the done btn block
  })
  /****************** step 4 ribbon BLOCK END HERE **********************/

  /****************** step 4.5 details BLOCK start HERE **********************/

  $('.step-blk_cutbtn.details_added').click(function () {
    var shipping_date = $('#shipping_date').val();
    //var shipping_instructions = $('#shipping_instructions').val();
    var ready_preference = $('input[name=ready_preference]:checked').val();
    if (shipping_date) {
      $('.shipping-summary-date').html('<b>Shipping or Pickup Date</b>: ' + shipping_date);
    } else {
      $('.shipping-summary-date').html('<b>Shipping or Pickup Date</b>: As soon as possible');
    }

    /*
     if(shipping_instructions) {
      $('.shipping-summary-instructions').html('<b>Shipping or Pickup Date</b>: ' + shipping_instructions);
    }
    */

    if (ready_preference) {
      //console.log('1 - ready preference set', ready_preference);

      if (['as_soon_as_possible', 'rush'].includes(ready_preference)) {

        //console.log('2 - ready preference set is soon as possible', ready_preference);

        $('.step-blk_cutbtn.details_added').css({ 'background-color': '#3b3b39' }).text('Go To Final Step');

        $('.js-step-trigger .step-li-5 .js-step-trigger-5').removeClass('isActive');

        $('.js-step-trigger .step-li-6').click().removeClass('make-untouchable').addClass('isActive');
        $('.js-step-trigger .step-li-6 .js-step-trigger-6').addClass('isActive');

        // Get the shipping date and instructions values and add them to the final details screen
        create_product_add_to_cart();


      } else {
        //console.log('3 - ready preference set is NOT soon as possible', ready_preference);

        if (shipping_date && shipping_date != '') {
          //console.log('4 - ready preference set is NOT soon as possible HAVE SHIPPING', ready_preference, shipping_date);


          $('.step-blk_cutbtn.details_added').css({ 'background-color': '#3b3b39' }).text('Go To Final Step');

          $('.js-step-trigger .step-li-5 .js-step-trigger-5').removeClass('isActive');

          $('.js-step-trigger .step-li-6').click().removeClass('make-untouchable').addClass('isActive');
          $('.js-step-trigger .step-li-6 .js-step-trigger-6').addClass('isActive');

          // Get the shipping date and instructions values and add them to the final details screen
          create_product_add_to_cart();


        } else {
          //console.log('5 - ready preference set is NOT soon as possible DONT HAVE SHIPPING', ready_preference, shipping_date);

          $('.step-blk_cutbtn.details_added').css({ 'background-color': 'red' }).text('Please fill out the date field above before continuing');

        }
      }


    } else {
      //console.log('6 - ready preference is NOT set', ready_preference);

      $('.step-blk_cutbtn.details_added').css({ 'background-color': 'red' }).text('Please select an option above before continuing');
    }
  });
  /****************** step 4.5 details BLOCK end HERE **********************/

  $("#alert_alert_read_4 #cancelok_me_14,#alert-alert-read #cancel_me_11").click(function(){
    $("#product_modal_popup_113 .close-product-popup").click();
  })

  $('body').on('click', 'p.addedintheboxplus', function(){
    if($(this).parents("div#product_modal_popup_113").hasClass("product__modal__box")){
      var getcurrentquantity = $(this).siblings("span").children(".addednumber").html();
      var getmaxstock = $(".popupopenedli").find(".AddtoBox").attr("data-stock");
      if(getcurrentquantity < getmaxstock){
        getcurrentquantity = parseInt(getcurrentquantity)+1;
        $(this).siblings("span").children(".addednumber").html(getcurrentquantity);
      }
      $(".popupopenedli p.addedintheboxplus").trigger("click");
    }
    else{
      console.log("simpleclicked");
      var total_prod_in_box = 0;
      $(".product_container .prod_list li.type__products").each(function(){
        var cuur = $(this).attr("data-added");
        total_prod_in_box = parseInt(total_prod_in_box) + parseInt(cuur);
      })

      var getcurrentquantity = $(this).siblings("span").children(".addednumber").html();
      var getmaxstock = $(this).parents(".addedinthebox").siblings(".AddtoBox").attr("data-stock");

      var box_capacity = $("#selected_box_capacity_11").val();
      if (box_capacity.indexOf('-') > -1)
      {
        box_capacity = box_capacity.split("-");
        var min_data = parseInt(box_capacity[0]); var max_data = parseInt(box_capacity[1]);
        //  console.log("min_data : "+min_data+" == max_data :"+max_data);
      }
      else
      {
        var min_data = parseInt(box_capacity); var max_data = parseInt(box_capacity);
      }

      if(getcurrentquantity == getmaxstock){
        $(this).addClass("untouchablel");
      }
      else{
        if(total_prod_in_box < max_data){
          getcurrentquantity = parseInt(getcurrentquantity)+1;
          $(this).siblings("span").children(".addednumber").html(getcurrentquantity);
          var currentThis = $(this).parents(".addedinthebox").siblings(".AddtoBox");
          AddToBoxList(currentThis);
          $(this).removeClass("untouchablel");

          var total_prod_in_box = 0;
          $(".product_container .prod_list li.type__products").each(function(){
            var cuur = $(this).attr("data-added");
            total_prod_in_box = parseInt(total_prod_in_box) + parseInt(cuur);
          })
        }
      }
      console.log(total_prod_in_box+"==="+max_data);
      if(total_prod_in_box == max_data){
        setTimeout(function(){
          $("#alert-alert-read .alert-footer").show();
          //var insert_html = 'YOUR BOX IS FULL WITH <span class="box_capacityy">'+max_data+' ITEMS</span> '
          if(max_data == 3){
            var insert_html = 'Your box is full with <span class="box_capacityy">'+max_data+' items. You can always change the size of your box to add more items by selecting Step 1 in your progress bar</span> '
            }
          else{
            var insert_html = 'YOUR BOX IS FULL WITH <span class="box_capacityy">'+max_data+' ITEMS</span> '
            }
          $("#alert-alert-read .alert-desc").html(insert_html);
          $("#overlay_of_box_11,#alert-alert-read").fadeIn();
        }, 500);
      }
    }
  })

  $('body').on('click', 'p.addedintheboxminus', function(){
    if($(this).parents("div#product_modal_popup_113").hasClass("product__modal__box")){
      var getcurrentquantity = $(this).siblings("span").children(".addednumber").html();
      getcurrentquantity = parseInt(getcurrentquantity)-1;
      if(getcurrentquantity > 0){
        $(this).siblings("span").children(".addednumber").html(getcurrentquantity);
      }
      $(".popupopenedli p.addedintheboxminus").trigger("click");
    }
    else{
      var getcurrentquantity = $(this).siblings("span").children(".addednumber").html();
      var prod_pureprice = $(this).parents(".addedinthebox").siblings(".AddtoBox").attr("data-pureprice");
      var getmaxstock = $(this).parents(".addedinthebox").siblings(".AddtoBox").attr("data-stock");
      if(getcurrentquantity < getmaxstock){
        $(this).siblings(".addedintheboxplus").removeClass("untouchablel");
      }

      getcurrentquantity = parseInt(getcurrentquantity)-1;
      if(getcurrentquantity > 0){
        $(this).siblings("span").children(".addednumber").html(getcurrentquantity);
        var getproid = $(this).parents(".addedinthebox").siblings(".AddtoBox").attr("data-id");
        $(".product_container .prod_list .type__products").each(function(){
          var getidd = $(this).children("a").attr("data-id");
          if(getidd == getproid){
            $(this).attr("data-added",getcurrentquantity)
            $(this).children("a").children(".curadded").html(getcurrentquantity);
          }
        })

        $(".p_title_list .list-items .type__productPrice").each(function(){
          var getidd = $(this).children(".remove-product").attr("data-id");
          var prod_pureprice_new = parseFloat(prod_pureprice) * parseFloat(getcurrentquantity);
          prod_pureprice_new = (prod_pureprice_new/100).toFixed(2);
          prod_pureprice_new = "$"+prod_pureprice_new+" CAD" ;
          if(getidd == getproid){
            $(this).children(".quantity").html(getcurrentquantity);
            $(this).children(".price").children(".base-price").html(prod_pureprice_new);

          }
        })

        totalpriceAddedproduct();
      }
    }
  })

});

//end of document dot ready
